import { render } from "./showCampagne.vue?vue&type=template&id=87d7b49e&ts=true"
import script from "./showCampagne.vue?vue&type=script&lang=ts"
export * from "./showCampagne.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__